import { r as registerInstance, h, H as Host } from './index-DFuxYijk.js';

const ProactiveCaseClosureModal = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.successMessageWasShown = false;
        /**
         * Environment to use for API calls
         */
        this.env = "prod";
        /**
         * use onprem Public API instead of azure
         * @deprecated only used until April 2025
         */
        this.legacyApi = false;
        /**
         * Debug mode
         * @deprecated do not use in production
         */
        this.debug = false;
        this.handleClose = () => {
            this.modal.triggerClose();
        };
        this.handleModalClose = () => {
            if (this.successMessageWasShown) {
                window.location.reload();
            }
        };
    }
    render() {
        return (h(Host, { key: 'ce950a70e751cd50734818b21fc620d892f7b7ed' }, h("ux-modal", { key: 'fdd714c59a64255a42b62ffccafc879418c2517b', onUxModalClose: () => this.handleModalClose(), name: this.modalName, ref: (el) => (this.modal = el) }, h("ux-modal-content", { key: 'cebb93a6b90b40c0ed427fc6b3a1205e996c79d9' }, h("mf-proactive-case-closure", { key: 'c5eeb007f9c1bb243717330162ac0a88f44c76ce', callId: this.callId, locale: this.locale, onMfServiceCallCancel: () => this.handleClose(), onMfServiceCallSuccess: () => {
                this.handleClose();
                window.location.reload();
            }, onMfServiceCallShowSuccess: () => (this.successMessageWasShown = true), env: this.env, legacyApi: this.legacyApi, debug: this.debug })))));
    }
};

export { ProactiveCaseClosureModal as mf_proactive_case_closure_modal };
//# sourceMappingURL=mf-proactive-case-closure-modal.entry.js.map

//# sourceMappingURL=mf-proactive-case-closure-modal.entry.js.map